import React, { useState } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="home-nav">
      <a href="/">
      <div className="home-logo-text">
        <h1>EMILIA</h1>
        <span className="home-logo-subtitle">NAIL STUDIO</span>
      </div>
      </a>

      {/* Botón hamburguesa para móviles */}
      <button className="home-nav-hamburger" onClick={toggleMenu} aria-label="Menú">
        <span className={menuOpen ? "bar rotate1" : "bar"}></span>
        <span className={menuOpen ? "bar fade" : "bar"}></span>
        <span className={menuOpen ? "bar rotate2" : "bar"}></span>
      </button>

      <nav className={`home-nav-links ${menuOpen ? "open" : ""}`}>
        <a href="#nosotros" onClick={() => setMenuOpen(false)}>NOSOTROS</a>
        <a href="#servicios" onClick={() => setMenuOpen(false)}>SERVICIOS</a>
        <a href="#contacto" onClick={() => setMenuOpen(false)}>CONTÁCTANOS</a>
        <a href="/services" onClick={() => setMenuOpen(false)}>¡RESERVA AHORA!</a>
      </nav>

      <div className="home-social-icons">
        <a href="https://www.instagram.com/valentina_nails22" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          {/* SVG de Instagram */}
        </a>
        <a href="https://wa.me/51932587523" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
          {/* SVG de WhatsApp */}
        </a>
      </div>
    </header>
  );
}
